import { NavLink } from "react-router";

import LogoMarkIcon from "@/assets/icons/logo1.svg?react";
import LogoWordmarkIcon from "@/assets/icons/logo2.svg?react";
import { CLIENT_HEADER_INSET_X } from "@/components/layout/client-insets";
import { useClientBasePath } from "@/hooks/use-client-base-path";
import { cn } from "@/lib/utils";

export function ClientHeader() {
  const basePath = useClientBasePath();

  return (
    <header className="relative z-40 w-full">
      <div
        className={cn(
          "flex w-full items-center pt-8 sm:pt-12 lg:pt-16",
          CLIENT_HEADER_INSET_X,
        )}
      >
        <NavLink
          to={basePath}
          className="flex min-w-0 flex-wrap items-center gap-x-2.5 gap-y-2"
          aria-label="Enbros Digital Workforce"
        >
          <span className="flex shrink-0 items-center gap-1">
            <LogoMarkIcon
              aria-hidden
              className="h-4 w-3 sm:h-[19px] sm:w-[15px]"
            />
            <LogoWordmarkIcon
              aria-hidden
              className="h-4 w-[68px] sm:h-[19px] sm:w-[81px]"
            />
          </span>
          <span
            aria-hidden
            className="hidden h-4 w-px shrink-0 bg-[rgba(255,255,255,0.35)] sm:block sm:h-[21px]"
          />
          <span className="whitespace-nowrap font-['Inter'] text-xs font-normal leading-5 tracking-[-0.16px] text-[#9194a1] sm:text-base sm:leading-[22px]">
            DIGITAL WORKFORCE
          </span>
        </NavLink>
      </div>
    </header>
  );
}
